import BackArrowIcon from '@mui/icons-material/ArrowBackRounded';
import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';

import useFlowNavigation from '#client/hooks/useFlowNavigation';

function BackButton({ disableBack }) {
  const { goToPrevPage } = useFlowNavigation();

  return (
    <Box>
      <Button
        clickstreamProps={{
          elementName: 'back_link'
        }}
        data-testid="back-link"
        disabled={disableBack}
        icon={<BackArrowIcon />}
        size="sm"
        sx={(theme) => ({
          marginInlineStart: `-${theme.spacing(2)}`
        })}
        variant="text"
        onClick={() => {
          goToPrevPage();
        }}
      >
        <FormattedMessage id="shopping.pageHeader.backButton.label" />
      </Button>
    </Box>
  );
}

BackButton.propTypes = {
  disableBack: PropTypes.bool
};

export default BackButton;
